import React, { useContext, useState } from "react";

import { AppContext } from "../context/AppContext";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import { CartContext } from "../context/CartContext";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Snackbar from "@mui/material/Snackbar";
import Star from "@mui/icons-material/Star";
import Typography from "@mui/material/Typography";
import { centsToCurrency } from "../services/firebase";
import { useNavigate } from "react-router-dom";

function PassItem({ name, description, amount, onSale, addToCart }) {
  return (
    <Grid item xs={12} sm={6} md={6}>
      <Card
        sx={{
          display: "flex",
          height: "100%",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <CardHeader
          title={
            <Typography variant="h5" color={onSale ? "success" : "default"}>
              {name}
            </Typography>
          }
          avatar={
            onSale ? <Star color={onSale ? "success" : "default"} /> : null
          }
        />
        <CardContent sx={{ flexGrow: 1 }}>
          <Typography variant="body1">{description}</Typography>
        </CardContent>
        <CardActions>
          <Button
            sx={{ fontSize: "1.25rem" }}
            variant="contained"
            fullWidth
            onClick={() => addToCart()}
          >
            {centsToCurrency(amount)}
          </Button>
        </CardActions>
      </Card>
    </Grid>
  );
}

export const Passes = () => {
  const navigate = useNavigate();
  const { passTemplates } = useContext(AppContext);
  const { addToCart } = useContext(CartContext);

  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("Added to Cart");

  const handleClose = () => {
    setOpen(false);
  };

  const goToCheckout = () => {
    navigate("/checkout");
  };

  const handleAddToCart = (pass) => {
    addToCart(pass);
    setMessage(`${pass.name} added to cart`);
    setOpen(true);
  };

  // Day passes are no longer sold - the club is open by appointment,
  // events & private bookings only.
  const availablePasses = passTemplates.filter((pass) => pass.type !== "day");

  if (availablePasses.length === 0) {
    return null;
  }

  return (
    <Box>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        autoHideDuration={6000}
        key="topcenter"
        message={message}
        onClose={handleClose}
        open={open}
        action={
          <Button color="warning" size="small" onClick={goToCheckout}>
            Checkout
          </Button>
        }
      />
      <Paper elevation={6} sx={{ p: 2, mt: 4, mb: 4 }}>
        <Grid container spacing={2}>
          {availablePasses.map((pass) => (
            <PassItem
              key={pass.type}
              {...pass}
              addToCart={() => handleAddToCart(pass)}
            />
          ))}
        </Grid>
      </Paper>
    </Box>
  );
};
